import { Observable } from 'rxjs-compat';
import { AngularFirestore } from 'angularfire2/firestore';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import { DataBaseProvider } from '../data-base/data-base';

/*
Provides user authentication services
*/
@Injectable()
export class AuthServiceProvider {
  public authState: any = null;
  authObs: Observable<any>;
  credential: any;
  mobileNumber: string;
  currentUserKey: string;
  currentUserInfo: string;
  constructor(public afAuth: AngularFireAuth,
    public $db: DataBaseProvider) {
    firebase.auth().languageCode = 'en';
    this.afAuth.authState.subscribe((auth) => {
      this.authState = auth;
      if (auth) {
        this.currentUserKey = auth.uid;
        console.log('the current user key is ', this.currentUserKey);
        this.populateCurrentUserInfo(auth.uid);
        this.handelNewUser(this.currentUserKey, auth.email);
      }
    }, err => {
      console.log('auth lost');
    });
  }

  signIn(userName, password): Promise<any> {
    return this.afAuth.auth.signInWithEmailAndPassword(userName, password);
  }

  signOut() {
    this.afAuth.auth.signOut().then(_ => {
      console.log('you have successfully logged out ');
    })
  }

  // returns the auth state observable
  authStateObs(): Observable<any> {
    return this.afAuth.authState;
  }

  getCurrentUserKey() {
    return this.currentUserKey ? this.currentUserKey : '';
  }

  /**
   * when there is new user 
   * insert new records to the DB
   */
  handelNewUser(userKey, userEmail) {
    this.$db.getUserInfo(userKey).subscribe(data => {
      console.log('the data is ', data);
      // new User
      if (!data) {
        this.$db.initializeUser(userKey, userEmail);
      }
    })
  }


  populateCurrentUserInfo(userKey): any {
    this.$db.getUserInfo(userKey).subscribe(data => {
      this.currentUserInfo = data;
      console.log('the current user info', this.currentUserInfo);
    })
  }

  /**
   * get the user info stored for a user
   */
  getCurrentUserInfo(): any {
    return this.currentUserInfo;
  }

  /**
   * logOut 
   */
  logOut(): Promise<any> {
    return this.afAuth.auth.signOut();
  }

  /**
   * returns the observable of 
   * the user being an admin or not
   */
  isAdmin(): Observable<any> {
    return this.$db.isAdminUser(this.currentUserKey);
  }

   /**
   * returns the observable of 
   * the user being an SuperAdmin or not
   */
  isSuperAdmin(): Observable<any> {
    return this.$db.isSuperAdminUser(this.currentUserKey);
  }


  /**
   * returns the observable of
   * the user's / tenant type
   */
  getTenantInfo(): Observable<any> {
    return this.$db.getTenantInfo(this.currentUserKey);
  }

  /**
   * get current user info obs
   */
  getCurrentUserObs():Observable<any>{
    return this.$db.getUserInfo(this.currentUserKey);
  }




}



// WEBPACK FOOTER //
// ./src/providers/auth-service/auth-service.ts